import ADatePicker from './src/DatePicker';

export const DatePicker = ADatePicker;

export default DatePicker;

export * from './src/DatePicker';
// export * from './src/generatePicker/interface';
// export * from './src/generatePicker/props';
